import React from 'react';
import Layout from '../Layout';
import { Container, Box, Grid } from '@material-ui/core';
import PostAddIcon from '@material-ui/icons/PostAdd';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import RssFeedIcon from '@material-ui/icons/RssFeed';
import GroupIcon from '@material-ui/icons/Group';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
// import "../BreakDown/Breakdown.css";
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';

const MailManagement = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' }
    ];

    const handler = (route) => {
        navigate(route)
    }
    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <ResponsiveTypography>
                        Mail Management
                    </ResponsiveTypography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Mail Management" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/mail-management/add-broadcast-channel")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <RssFeedIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Add Broadcast Channel
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/mail-management/add-broadcast-users")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <GroupIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                       Add Broadcast Users
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/mail-management/add-templates")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PostAddIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                       Add Templates
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/mail-management/add-event")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <EventAvailableIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                       Add Event
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                   
                </Box>
            </Container>
        </Layout>
    );
};

export default MailManagement;
